module.exports = __webpack_public_path__ + "static/media/naka-itabashi-2.29d3ddf4.jpg";